<template>
  <v-app id="App">
    <core-app-bar :class="this.$vuetify.breakpoint.name!='sm'&
                          this.$vuetify.breakpoint.name!='xs'?`barset`:``"/>

    <!-- <core-drawer /> -->

    <core-view />

    <core-footer />
    <whatsapp/>
<!-- <div id="fb-root"></div> -->
      
      <!-- Your Chat Plugin code -->
      <!-- <div class="fb-customerchat"
        attribution=setup_tool
        page_id="805435602820500"
  logged_in_greeting="Hola! En qué te puedo ayudar?"
  logged_out_greeting="Hola! En qué te puedo ayudar?">
      </div> -->
      
      <!-- Your Chat Plugin code -->
      <!-- <div class="fb-customerchat" -->
        <!-- attribution=setup_tool -->
        <!-- page_id="109228210837371" -->
  <!-- logged_in_greeting="Hola, en qué te puedo ayudar?" -->
  <!-- logged_out_greeting="Hola, en qué te puedo ayudar?"> -->
      <!-- </div> -->
    <!-- <core-cta /> -->
  </v-app>
</template>

<script>

  export default {
    name: 'App',

    components: {
      // CoreCta: () => import('@/components/core/Cta'),
      // CoreDrawer: () => import('@/components/core/Drawer'),
      whatsapp: () => import('@/components/base/whatsapp'),
      CoreFooter: () => import('@/components/core/Footer'),
      CoreAppBar: () => import('@/components/core/AppBar'),
      CoreView: () => import('@/components/core/View'),
    },
    created(){
     
      // console.log(this.$recaptchaInstance)
      // console.log(FB)
        //   window.fbAsyncInit = function() {
            
        //   this.FB.init({
        //     xfbml            : true,
        //     version          : 'v7.0'
        //   });
        // };
    }
  }
  
</script>
<style scoped>
.barset {
  position: absolute;
  background: transparent;
  z-index: 100;
}

</style>
<style lang="scss">
@import "@/assets/base.scss";
  .v-application {
    font-family: 'Nunito', sans-serif !important;
  }
</style>

